import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { LogistikRoutes } from '@chancenlogistik/client/routes';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement logistik-page-no-permission
 */
@customElement('logistik-page-no-permission')
export class LogistikPageNoPermission extends ChemistryLitElement {
  override render() {
    return html`
      <cr-flex crossaxis-center center space="md">
        <cr-text>Sie haben nicht die Befugnis, diese Seite zu sehen!</cr-text>
        <cr-button mode="outline" @click=${() => goTo(LogistikRoutes.landing)}> Zurück zu deinem Bereich </cr-button>
      </cr-flex>
    `;
  }
}
